import React from 'react';

const DuckStory: React.FC = () => {
    const chapters = [
        {
            emoji: '🥚',
            title: 'The Genesis Egg',
            text: 'In the deep purple waters of the Monad blockchain, a mysterious golden egg appeared. No one knew where it came from. Some say it was dropped by Satoshi himself on his way to the moon.',
        },
        {
            emoji: '🐣',
            title: 'The Hatching',
            text: 'On a fateful day at nad.fun, the egg cracked open. Out came $DUCK — the most unhinged, fearless, and absolutely based aquatic bird the crypto world had ever seen. His first words? "QUACK TO THE MOON!"',
        },
        {
            emoji: '🦆',
            title: 'The Pond Grows',
            text: 'Word spread fast. Degens, chads, and diamond-handed legends from across the blockchain gathered at the pond. $DUCK wasn\'t just a token — it became a movement. A brotherhood of quackers.',
        },
        {
            emoji: '🚀',
            title: 'The Migration',
            text: 'Now, $DUCK prepares for the greatest migration in memecoin history. From the bonding curve to the stratosphere. Every holder is a wing in this flight. The pond is everywhere. The quack is eternal.',
        },
    ];

    return (
        <section id="story" className="section duck-story-section">
            <h2 className="section-title">📖 The Legend of $DUCK</h2>
            <p className="story-intro">
                Every great memecoin has an origin story. This is ours.
            </p>

            <div className="story-timeline">
                {chapters.map((chapter, index) => (
                    <div key={index} className="story-chapter glass-card">
                        <div className="story-chapter-number">{index + 1}</div>
                        <div className="story-chapter-emoji">{chapter.emoji}</div>
                        <h3 className="story-chapter-title">{chapter.title}</h3>
                        <p className="story-chapter-text">{chapter.text}</p>
                    </div>
                ))}
            </div>

            <div className="story-quote glass-card">
                <p className="story-quote-text">
                    "In a world of rugs and scams, one duck dared to be different.
                    One duck dared to be... $DUCK."
                </p>
                <span className="story-quote-author">— Ancient Monad Proverb</span>
            </div>
        </section>
    );
};

export default DuckStory;
